import React from 'react'
import { Flex, Text } from '../../vanilla'
import {useOrderStore, useBasketStore} from '../../store/hooks/useStore'
import {FormattedNumber} from 'react-intl'

interface ShoppingTotalProps {
  inDrawer?: boolean
}

export const ShoppingTotal = ({ inDrawer }: ShoppingTotalProps) => {
  const { orderTotal } = useOrderStore()
  const { basket } = useBasketStore()

  return (
    <Flex flexDirection="column" align="flex-end">
      <Text
        variant="unstyled"
        fontSize={inDrawer ? 'md' : 'xs'}
        fontWeight={inDrawer ? "normal" : ["normal", "medium"]}
        as="span"
        lineHeight="none"
        data-test-selector={inDrawer ? "cart-drawer-basket-total" : "basket-total-amount"}
      >
        {orderTotal ? 
          <FormattedNumber
            style="currency"
            currency={basket?.currency}
            value={orderTotal}
          /> : '£0.00'
        }
      </Text>
      <Text
        color="textMuted"
        variant="unstyled"
        fontSize="xxs"
        fontWeight="normal"
        lineHeight="none"
        data-test-selector="inc-fees-text"
      >
        inc. fees
      </Text>
    </Flex>
  )

}